<template>
  <div class="container" @mouseenter="onCate()" @mouseleave="offCate()">
    <div class="site-category" :class="global.isShowCate ? 'show' : 'hidden'">
      <ul class="site-category-list">
        <li class="category-item" v-for="(item, index) in goods_category_tree" :key="index">
          <a>{{ item.name }} <em class="iconfont-arrow-right-big"></em></a>
          <div class="category-panel">
            <el-scrollbar height="460px">
              <div v-for="(child_item, child_index) in item._child" :key="child_index">
                <a class="title" @click="goChildCate(child_item)">
                  {{ child_item.name }}
                </a>
                <a v-for="(grand_item, grand_index) in child_item._child" :key="grand_index"
                  @click="goGrandCate(grand_item)">
                  {{ grand_item.name }}
                </a>
              </div>
            </el-scrollbar>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { api, session } from "@/assets/js/util.js";
export default {
  name: "SiteCategory",
  inject: ["global"],
  data() {
    return {
      goods_category_tree: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    onCate() {
      this.global.isOnCate = true;
      this.global.isShowCate = true;
    },
    offCate() {
      this.global.isOnCate = false;
      this.global.isShowCate = false;
    },
    goChildCate(child) {
      //this.$router.push({ name: "Transfer", params: { url: '/category/child/'+child.name } });
      this.$router.push({ path: "/category/child/" + child.name, params: 'child' });
    },
    goGrandCate(grand) {
      //this.$router.push({ name: "Transfer", params: { url:'/category/grand/'+grand.name } });
      this.$router.push({ path: "/category/grand/" + grand.name, params: 'grand' });
    },
    getData() {
      let that = this;
      let goods_category_tree = session.get("goods_category_tree");
      if (!goods_category_tree === true) {
        api.get("goods_category_tree").then(function (res) {
          if (res.code) {
            session.set("goods_category_tree", res.data.goods_category_tree);
            that.goods_category_tree = session.get("goods_category_tree");
          }
        });
      } else {
        that.goods_category_tree = session.get("goods_category_tree");
      }
    },
  },
};
</script>
<style scoped>
.container {
  position: relative;
  left: 0px;
}

.site-category.show {
  display: block !important;
}

.site-category.hidden {
  display: none;
}

.site-category {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 21;
  width: 234px;
  height: 460px;
  font-size: 14px;
  background: rgba(105, 101, 101, 0.6);
}

.site-category-list {
  height: 418px;
  margin: 0;
  padding: 10px 0;
  list-style-type: none;
}

.category-item {
  height: 42px;
  padding-left: 20px;
  cursor: pointer;
}

.category-item>a {
  color: #fff;
  line-height: 42px;
  position: relative;
  display: inline-block;
  width: 100%;
}

.category-item:hover .category-panel {
  display: block;
}

.category-panel {
  display: none;
  position: absolute;
  left: 234px;
  top: 0px;
  width: 992px;
  background: #fff;
  box-shadow: rgba(5, 34, 97, 0.1) 0px 2px 7px 0px;
  color: 555;
  padding-left: 15px;
  padding-top: 7px;
  padding-bottom: 7px;
  box-sizing: border-box;
  height: 460px;
}

.category-panel .title {
  color: #2794eb;
  font-weight: 700;
}

.category-panel a {
  color: #555;
  padding-left: 7px;
  padding-right: 7px;
  line-height: 36px;
}

.site-category-list em[class*="iconfont"] {
  position: absolute;
  top: 12px;
  right: 10px;
  font-size: 16px;
  line-height: 16px;
  color: #e0e0e0;
}
</style>
